
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prikbord",
      function () {
        return require("private-next-pages/prikbord/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prikbord"])
      });
    }
  